import React from 'react';
import { isPagingNeeded } from '../../utils/pagination';
import { usePaginationContext } from '../../contexts/PaginationContext';
import PaginationButton from './PaginationButton';

const Pagination = () => {
	const { itemsPerPage, totalCount, goToNextPage, goToPreviousPage } =
		usePaginationContext();

	const paging = {
		pageSize: itemsPerPage,
		totalCount
	};

	if (!isPagingNeeded(paging)) {
		return null;
	}

	return (
		<nav aria-label="Page navigation">
			<ul className="pagination">
				<PaginationButton
					direction="previous"
					onPageChange={goToPreviousPage}
				/>
				<PaginationButton
					direction="next"
					onPageChange={goToNextPage}
				/>
			</ul>
		</nav>
	);
};

export default Pagination;
